import { Radio } from '../Radio'

interface RadioGroupProps {
  options: Array<{ id: string; name: string; checked?: boolean }>
  label: string
  onChange: any
  value: string
}

export const RadioGroup = (props: RadioGroupProps) => {
  const { options, label } = props

  return (
    <div>
      <div className="text-gray-500">{label}</div>
      <div className="flex flex-row">
        {options.map((option) => (
          <Radio
            key={option.id}
            label={option.name}
            value={option.id}
            id={option.id}
            checked={option.checked || false}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              console.log(event)
            }
            onClick={(
              checked: boolean,
              setChecked: React.Dispatch<React.SetStateAction<boolean>>
            ) => {
              if (!checked) {
                setChecked(true)
              }
            }}
          />
        ))}
      </div>
    </div>
  )
}
